import {
  JwtType,
  LoginError,
  LoginMethod,
  UserRole,
  UserStatus,
} from '../../enums/auth.enums';
import { Competition } from '../../enums/team.enums';
import { DEFAULT_COMBINED_PERMISSIONS } from '../../interfaces/i-permissions';
import { IAuthToken, SessionMode } from '../i-auth-token';
import { ITeam } from '../i-team';

export interface ILoginPayload {
  email: string;
  password: string;
}

export interface IResetPasswordPayload extends ILoginPayload {
  code: string;
}

/** for successful logins */
export interface ILoginSuccess extends IAuthToken {
  /** ms */
  token: string;
}

/** for unsuccessful logins */
export interface ILoginError {
  message: string;
  type: LoginError;
}

/** for passing things around */
export interface ILoginResult {
  /** only defined when login succeeded */
  success?: ILoginSuccess;
  /** only defined when login succeeded */
  team?: ITeam;
  /** only defined when login failed */
  error?: ILoginError;
}

export interface ISessionCurrent extends ILoginSuccess {
  auth: boolean;
}

export interface IRefreshTokenPayload {
  createNewSessionID: boolean;
  currentSessionID?: string; // to maintain the current session ID between refreshes
}

export const DEFAULT_SESSION_UNAUTH: ISessionCurrent = {
  method: LoginMethod.None,
  version: '',
  auth: false,
  email: '',
  expiresAt: new Date().toISOString(),
  refreshExpiresAt: new Date().toISOString(),
  machineID: '',
  role: UserRole.basic,
  session: '',
  wsID: '',
  status: UserStatus.unverified,
  type: JwtType.auth,
  teamID: 'none',
  team: 'none',
  abbreviation: null,
  league: Competition.None,
  userID: '',
  mode: SessionMode.Basic,
  token: '',
  ...DEFAULT_COMBINED_PERMISSIONS,
};

export interface IAuthSessionCookie {
  auth: boolean;
  email: string;
  method: LoginMethod;
}

export const DEFAULT_AUTH_SESSION: IAuthSessionCookie = {
  auth: false,
  email: '',
  method: LoginMethod.None,
};
